import createIcon from '../../createIcon';

/**
 * @component @name WifiFind
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTEgMTMuNUMxMSAxMC4xNCAxMy42NCA3LjUgMTcgNy41QzE5LjIgNy41IDIxLjA4IDguNjMgMjIuMTMgMTAuMzZMMjQgOC40OEMyMC45MyA1LjQgMTYuNjkgMy41IDEyIDMuNUM3LjMxIDMuNSAzLjA3IDUuNCAwIDguNDhMMTIgMjAuNUwxMy44NiAxOC42M0MxMi4xNCAxNy41OSAxMSAxNS43IDExIDEzLjVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMjEgMTMuNUMyMSAxMS4yNiAxOS4yNCA5LjUgMTcgOS41QzE0Ljc2IDkuNSAxMyAxMS4yNiAxMyAxMy41QzEzIDE1Ljc0IDE0Ljc2IDE3LjUgMTcgMTcuNUMxNy43NSAxNy41IDE4LjQ0IDE3LjI5IDE5LjAzIDE2Ljk0TDIxLjU5IDE5LjVMMjMgMTguMDlMMjAuNDQgMTUuNTNDMjAuNzkgMTQuOTQgMjEgMTQuMjUgMjEgMTMuNVpNMTUgMTMuNUMxNSAxMi4zOCAxNS44OCAxMS41IDE3IDExLjVDMTguMTIgMTEuNSAxOSAxMi4zOCAxOSAxMy41QzE5IDE0LjYyIDE4LjEyIDE1LjUgMTcgMTUuNUMxNS44OCAxNS41IDE1IDE0LjYyIDE1IDEzLjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const WifiFind = createIcon('WifiFind', [
  [
    'path',
    {
      d: 'M11 13.5C11 10.14 13.64 7.5 17 7.5C19.2 7.5 21.08 8.63 22.13 10.36L24 8.48C20.93 5.4 16.69 3.5 12 3.5C7.31 3.5 3.07 5.4 0 8.48L12 20.5L13.86 18.63C12.14 17.59 11 15.7 11 13.5Z',
      key: 'agdvj5',
    },
  ],
  [
    'path',
    {
      d: 'M21 13.5C21 11.26 19.24 9.5 17 9.5C14.76 9.5 13 11.26 13 13.5C13 15.74 14.76 17.5 17 17.5C17.75 17.5 18.44 17.29 19.03 16.94L21.59 19.5L23 18.09L20.44 15.53C20.79 14.94 21 14.25 21 13.5ZM15 13.5C15 12.38 15.88 11.5 17 11.5C18.12 11.5 19 12.38 19 13.5C19 14.62 18.12 15.5 17 15.5C15.88 15.5 15 14.62 15 13.5Z',
      key: '15r8gw',
    },
  ],
]);

export default WifiFind;
